module.exports = __webpack_public_path__ + "img/3.d2194f6d.png";